import ratings from './ratings';

export default [...ratings];
